import type { ContentCategory } from './api.interface';

/**
 * 8 个内容分类的展示配色（UI 设计指南 3.3）。
 * tag：分类胶囊；cover：无封面时的占位色块；dot：筛选按钮前的色点。
 * 文字色与底色对比度均 ≥ 4.5:1。
 */
export interface CategoryStyle {
  tagBg: string;
  tagFg: string;
  coverBg: string;
  coverInk: string;
  dot: string;
}

export const CATEGORY_STYLES: Record<ContentCategory, CategoryStyle> = {
  traditional_culture: { tagBg: '#FBE7E3', tagFg: '#A0372B', coverBg: '#F2CFC6', coverInk: '#8E2E24', dot: '#D4695B' },
  idiom_fable: { tagBg: '#FBEFD8', tagFg: '#83560C', coverBg: '#F3DDB0', coverInk: '#6E480A', dot: '#D9A23A' },
  patriotic_feeling: { tagBg: '#F8DFDC', tagFg: '#8C2420', coverBg: '#EFC2BD', coverInk: '#7A1E1B', dot: '#B9433C' },
  character_spirit: { tagBg: '#E1EFF7', tagFg: '#235F86', coverBg: '#C7E0EF', coverInk: '#1E5275', dot: '#4D8FBF' },
  city_feature: { tagBg: '#DEF1E8', tagFg: '#1E6A4F', coverBg: '#C3E4D5', coverInk: '#195A43', dot: '#45A07C' },
  myth_legend: { tagBg: '#ECE6F8', tagFg: '#57429A', coverBg: '#D8CEF1', coverInk: '#4A3786', dot: '#8A73CF' },
  classic_fairy_tale: { tagBg: '#F8E3F0', tagFg: '#8F316B', coverBg: '#EFC9E1', coverInk: '#7A2A5B', dot: '#C860A0' },
  picture_book_story: { tagBg: '#FCE9DA', tagFg: '#954615', coverBg: '#F6D2B5', coverInk: '#7F3B12', dot: '#DE8A4E' },
};

const FALLBACK_STYLE: CategoryStyle = {
  tagBg: '#F3EDE4',
  tagFg: '#5F5448',
  coverBg: '#EDE5D9',
  coverInk: '#5F5448',
  dot: '#B5A898',
};

export function getCategoryStyle(category: ContentCategory | string | null | undefined): CategoryStyle {
  return (category && CATEGORY_STYLES[category as ContentCategory]) || FALLBACK_STYLE;
}
